import { Component, ChangeDetectionStrategy } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { ParFormFieldComponent } from '@shared/ui';
import { DynamicFormControlDirective } from '../../dynamic-form-control.directive';
import { AbstractDynamicFormControl } from '../../abstact-dynamic-form-control.directive';

@Component({
  selector: 'dynamic-form-number-control',
  templateUrl: 'number-control.component.html',
  styleUrls: ['number-control.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ReactiveFormsModule, ParFormFieldComponent],
  providers: [
    { provide: DynamicFormControlDirective, useExisting: DynamicFormNumberControlComponent },
  ],
})
export class DynamicFormNumberControlComponent extends AbstractDynamicFormControl {}
